// Each product's look on a tile, and its kind line, from its catalogue row: the Main and PhoneLibrary
// boards' tiles. Pure and importing nothing but lib/format.js, so a test can import it (library/model.js
// re-exports it for the app; portal.js uses it for the portal cards).
import * as f from '../lib/format.js'

export function accentKey(look, type) {
  if (look === 'funding_engine') return 'fe'
  if (look === 'poyt') return 'poyt'
  if (look === 'accelerator') return type === 'on_demand' ? 'pcfl' : 'acc'
  return 'master'
}

// The tile's art. Property Cashflow For Life's own (its house and its pentagon) is its alone, by its
// slug: another on-demand course in the Accelerator family (the product-types plan, 13 Oct) takes the
// Accelerator's.
export const isCashflow = p => p?.slug === 'cashflow'
export function artKind(p) {
  if (p.look === 'funding_engine') return 'fe'
  if (p.look === 'poyt') return p.type === 'masterclass' ? 'masterclass' : 'poyt'
  if (p.look === 'accelerator') return p.type === 'on_demand' && isCashflow(p) ? 'pcfl' : 'acc'
  return 'master'
}

export function kindLine(p, durationSeconds) {
  switch (p.type) {
    case 'live_cohort': return 'Live course'
    case 'mastermind': return 'Mastermind'
    case 'on_demand': return 'On demand'
    case 'masterclass': return durationSeconds ? `Video, ${f.duration(durationSeconds)}` : 'Video'
    case 'client_space': return '1-2-1'
    default: return 'Resources'
  }
}
